import { assert_number_gte_0, assert_string_not_empty, assert_type_number, not_implemented } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { MAP__serializable } from '../../_base/MAP__serializable';
import { DTODiffusionModelUDBase } from '../sd/_base/dto_diffusion_model_ud_base';
import { DTODiffusionModelsTablePageBase } from './dto_diffusion_model_table_page_base';

export type DTODiffusionModelsTableBase = DTODiffusionModelsTableGeneric<DTODiffusionModelsTablePageBase<DTODiffusionModelUDBase>>;

export abstract class DTODiffusionModelsTableGeneric<TPage extends DTODiffusionModelsTablePageBase<DTODiffusionModelUDBase>> extends DTO__base {
  /*
   * STATIC FIELDS
   */

  /*
   * FIELDS
   */

  //key - EDiffusionModelType, value - amount
  //total items amount = sum of all values
  items_amount_by_type_map!: MAP__serializable<string, number>;
  items_amount_by_type_all!: number;

  //key - EDiffusionModelBaseModel, value - amount
  items_amount_by_base_model_map!: MAP__serializable<string, number>;
  items_amount_by_base_model_all!: number;

  hash_crc32_settings_table!: string;

  //key - index, value DTODiffusionModelsTablePage
  pages_map: MAP__serializable<number, TPage>;

  /*
   * METHODS
   */

  constructor() {
    super();
    this.pages_map = new MAP__serializable();

    this.items_amount_by_type_map = new MAP__serializable();
    this.items_amount_by_base_model_map = new MAP__serializable();
  }

  assert_standard_fields(): void {
    assert_number_gte_0(this.items_amount_by_type_all);
    assert_number_gte_0(this.items_amount_by_base_model_all);
    assert_string_not_empty(this.hash_crc32_settings_table);
  }

  get_page_by_index(index: number): TPage {
    let out = this.pages_map.get(index);

    if (!out) {
      out = this.create_page_stub();
    }

    return out;
  }

  create_page_stub(): TPage {
    not_implemented();
  }

  add_page(page: TPage) {
    this.pages_map.set(page.index, page);
  }

  get_total_pages_amount() {
    assert_type_number(this.items_amount_by_type_all);

    return Math.ceil(this.items_amount_by_type_all / CONSTANTS__shared.DIFFUSION_MODELS_TABLE_PAGE_ITEMS_AMOUNT);
  }
}
